import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { Expose, Type } from "class-transformer";
import { ArrayMinSize, IsArray, IsEnum, IsInt, IsOptional, IsString, IsUUID, Min, ValidateNested } from "class-validator";
import { v4 as uuidv4 } from "uuid";

export class MonitoringDirectBomLine {
  @IsString()
  public partNumber: string;

  @IsString()
  public name: string;

  @IsInt()
  @Min(1)
  public quantity: number;

  constructor(partNumber: string, name: string, quantity: number) {
    this.partNumber = partNumber;
    this.name = name;
    this.quantity = quantity;
  }

  static create(partNumber: string, name: string, quantity = 1): MonitoringDirectBomLine {
    return new MonitoringDirectBomLine(partNumber, name, quantity);
  }
}

export class MonitoringDirectBomEntry {
  @IsUUID()
  public readonly id: string;

  @IsString()
  public name: string;

  @IsEnum(MonitoringCategory)
  public category: MonitoringCategory;

  @IsInt()
  @Min(0)
  public quantity: number;

  @IsString()
  @IsOptional()
  public positionNumber?: string;

  @IsArray()
  @ArrayMinSize(1)
  @ValidateNested({ each: true })
  @Type(() => MonitoringDirectBomLine)
  @Expose({ name: "lines" })
  public lines: MonitoringDirectBomLine[];

  constructor(
    id: string,
    name: string,
    category: MonitoringCategory,
    quantity: number,
    lines: MonitoringDirectBomLine[],
    positionNumber?: string,
  ) {
    this.id = id;
    this.name = name;
    this.category = category;
    this.quantity = quantity;
    this.lines = lines;
    this.positionNumber = positionNumber;
  }

  static create(
    name: string,
    category: MonitoringCategory,
    quantity: number,
    lines: MonitoringDirectBomLine[],
  ): MonitoringDirectBomEntry {
    return new MonitoringDirectBomEntry(uuidv4(), name, category, quantity, lines);
  }

  get mainProductId(): string | undefined {
    return this.lines[0]?.partNumber;
  }
}
